import React, { useEffect, useState } from 'react';
import AppFooter from '../components/footer/AppFooter';
import { getAppPlayerModel, getAppUserModel } from '../firebase/FireBaseManager';
import { AppPlayerModel, AppUserModel } from '../models/UserModel';
import { Button, Form } from 'antd';
import InputPlayerForm from '../components/form/player/InputPlayerForm';
import { convertToInsertPlayerInfoData } from '../firebase/FireBaseDataConverter';
import { scrollTop } from '../helpers/common';
import ConfirmPlayerForm from '../components/form/player/ConfirmPlayerForm';
import { cloudFunctionUpdateInfoPlayer } from '../firebase/FireBaseCloudFunction';
import { useHistory } from 'react-router-dom';
import LoadingScreen from '../components/LoadingScreen';
import { getFirebaseUserModel } from '../firebase/FireBaseManager';
import { uploadImageAsPromise } from '../firebase/FirebaseStorage';

const ProfileUpdatePage = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [imageFile, setImageFile] = useState(null);

  const userInfo = getAppUserModel() || new AppUserModel();
  const playerInfo = getAppPlayerModel() || new AppPlayerModel();

  const [isConfirm, setIsConfirm] = useState(false);
  const [inputCurrentData, setInputCurrentData] = useState(null);
  const [inputCurrentModel, setInputCurrentModel] = useState(playerInfo);
  const isUpdate = true;
  const loginUser = getFirebaseUserModel();
  const uid = loginUser?.uid;

  useEffect(() => {
    scrollTop();
  });

  /**
   * 確認ボタンが押された時
   * @param values
   */
  const handleConfirmRegister = (values) => {
    setInputCurrentData(values);
    setIsConfirm(true);
    const playerModel = convertToInsertPlayerInfoData(values);
    setInputCurrentModel(playerModel);
    scrollTop();
  };

  /**
   * 登録がボタンが押されたとき
   */
  const onClickSubmitButton = async () => {
    if (imageFile) {
      const image_url = await uploadImageAsPromise(imageFile, `public/player_images/${uid}`, '1');
      inputCurrentData['imageUrl'] = image_url;
    }
    const playerModel = convertToInsertPlayerInfoData(inputCurrentData);

    // ユーザ情報更新
    cloudFunctionUpdateInfoPlayer(
      {
        /**
         * 処理開始時
         */
        onProcessStart: () => {
          console.log('ProfileUpdatePage cloudFunctionUpdateInfoPlayer()');
          setIsLoading(true);
        },

        /**
         * 成功時
         */
        onSuccess: (_appPlayerModel) => {
          setIsLoading(false);
          // moveWindowByUserStatus(history, userStatusHook());
          history.push('/profile_update_completed');
        },

        /**
         * 失敗時
         */
        onFailed: () => {
          setIsLoading(false);
        },
      },
      playerModel
    );
  };

  if (isLoading) {
    return (
      <body>
        <LoadingScreen />;
      </body>
    );
  }

  return (
    <body className="c-screen">
      <header className="c-container-vertical c-mt16">
        <div className="c-logo c-logo--144">
          <img src="/images/logo--dark.svg" alt="JCG Management" className="c-logo__source" />
        </div>
        {!isConfirm && (
          <>
            <h1 className="c-heading--1 c-mt32">選手情報変更</h1>
          </>
        )}
        {isConfirm && (
          <>
            <h1 className="c-heading--1 c-mt32">選手情報変更確認</h1>
          </>
        )}
      </header>

      <main className="c-page-section">
        <h2 className="c-heading--2 c-mt32">
          {userInfo.given_name_kanji}
          {userInfo.family_name_kanji}
        </h2>

        <Form
          form={form}
          onFinish={handleConfirmRegister}
          scrollToFirstError
          initialValues={{
            imageUrl: playerInfo.image_url,
            shozoku: playerInfo.shozoku,
            height: playerInfo.height,
            bodyWeight: playerInfo.body_weight,
            bloodType: playerInfo.blood_type,
            birthplace: playerInfo.birthplace,
            school: playerInfo.school,
            goodClub: playerInfo.good_club,
            beginningAge: playerInfo.beginning_age,
            motivationStart: playerInfo.motivation_start,
            averageDistance: playerInfo.average_distance,
            bestScore: playerInfo.best_score,
            targetPerson: playerInfo.target_person,
            bankInfoBankName: playerInfo.bank_info.bank_name || '',
            bankInfoBranchName: playerInfo.bank_info.branch_name || '',
            bankInfoAccountType: playerInfo.bank_info.account_type || '',
            bankInfoAccountNumber: playerInfo.bank_info.account_number || '',
            bankInfoAccountHolder: playerInfo.bank_info.account_holder || '',
          }}
          className="c-input-form"
          id="profile-input-form"
        >
          {/* 入力画面 */}
          {!isConfirm && (
            <>
              <InputPlayerForm
                isUpdate={isUpdate}
                currentPlayer={inputCurrentModel}
                form={form}
                setImageFile={setImageFile}
              />

              <div className="c-button-set c-mt56 c-mb88">
                <Button htmlType="submit" id="next" className="button button__primary">
                  次へ
                </Button>
              </div>
            </>
          )}

          {/* 確認画面 */}
          {isConfirm && (
            <>
              <div className={`${!isConfirm ? 'hidden' : ''}`}>
                <ConfirmPlayerForm dataUser={inputCurrentData} isUpdate={isUpdate} />
              </div>

              <div className="c-button-set c-mt56 c-mb88">
                <Button className="button button__secondary" id="back" onClick={() => setIsConfirm(false)}>
                  修正する
                </Button>
                <Button className="button button__primary" id="next" onClick={onClickSubmitButton}>
                  送信
                </Button>
              </div>
            </>
          )}
        </Form>
      </main>

      <footer>
        <AppFooter />
      </footer>
    </body>
  );
};

export default ProfileUpdatePage;
